import { FORM_STATUS, QUESTION_TYPES } from './consultationForms.const';

let nextId = 5;
export const getNextId = () => String(nextId++);

export const MOCK_FORMS = [
  {
    id: '1',
    name: 'General Health',
    status: FORM_STATUS.DRAFT,
    icon: '❤️‍🩹',
    ruleTags: [
      { emoji: '🔔', category: 'Sends when', label: 'When appointment in created' },
      { emoji: '📋', category: 'Frequency', label: 'All appointments' },
      { emoji: '🔁', category: 'Services', label: 'Once per client' },
      { emoji: '⏳', category: 'Expires after', label: '3 months expiry' },
    ],
    questions: [
      { id: 'q1', text: 'Do you have any known allergies?', type: QUESTION_TYPES.LONG_ANSWER, required: true },
      { id: 'q2', text: 'Are you currently pregnant or breastfeeding?', type: QUESTION_TYPES.YES_NO, required: true },
    ],
  },
  {
    id: '2',
    name: 'Laser Treatment',
    status: FORM_STATUS.ACTIVE,
    icon: '⭐️',
    ruleTags: [
      { emoji: '🔔', category: 'Sends when', label: 'When appointment in created' },
      { emoji: '📋', category: 'Frequency', label: 'Selected services' },
      { emoji: '🔁', category: 'Services', label: 'Once per client' },
      { emoji: '⏳', category: 'Expires after', label: '3 months expiry' },
    ],
    questions: [{ id: 'q3', text: 'Have you had laser treatment before?', type: QUESTION_TYPES.YES_NO, required: true }],
  },
  {
    id: '3',
    name: 'Massage Therapy',
    status: FORM_STATUS.INACTIVE,
    icon: '💆',
    ruleTags: [
      { emoji: '🔔', category: 'Sends when', label: 'When appointment in created' },
      { emoji: '📋', category: 'Frequency', label: 'Selected services' },
      { emoji: '🔁', category: 'Services', label: 'Once per client' },
      { emoji: '⏳', category: 'Expires after', label: '3 months expiry' },
    ],
    questions: [
      { id: 'q4', text: 'Do you have any areas of pain or tension?', type: QUESTION_TYPES.LONG_ANSWER, required: true },
      {
        id: 'q5',
        text: 'What pressure level do you prefer?',
        type: QUESTION_TYPES.RADIO_BUTTONS,
        required: true,
        options: ['Light', 'Medium', 'Firm', 'Deep'],
      },
    ],
  },
  {
    id: '4',
    name: 'Custom form',
    status: FORM_STATUS.ACTIVE,
    icon: '🚀',
    ruleTags: [
      { emoji: '🔔', category: 'Sends when', label: 'When appointment in created' },
      { emoji: '📋', category: 'Frequency', label: 'Selected services' },
      { emoji: '🔁', category: 'Services', label: 'Once per client' },
      { emoji: '⏳', category: 'Expires after', label: '3 months expiry' },
    ],
    questions: [],
  },
];
